import { IGetAppointments } from "modules/Appointments/types";
import api from "utils/api.utils";

export const fetchMemberAppointments = {
  queryFn: async ({ memberId, accountId }: IGetAppointments) => {
    try {
      const response = await api.get(`members/${memberId}`, {
        "X-ACCOUNT-ID": accountId,
      });
      return response;
    } catch (err) {
      throw err;
    }
  },
  queryKey: ({ memberId, accountId }: IGetAppointments) => [
    memberId,
    accountId,
    "appointments",
  ],
};
